import React, { useEffect, useState } from 'react';
import {IProps} from './types';
import * as S from './styles';

const Loading:React.FC<IProps> = (props) => {  
  return (
    <S.Root style={props.containerStyle} >
        <S.Loading 
          id={props.id ? props.id : "loading-object"}
          pointsColor={props.pointsColor}
          style={props.loadingStyle} 
        />
    </S.Root>
  );
}

export default Loading;